import { FC, useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";

import { Button, FormControl, IconButton, MenuItem, Select, Stack, TextField } from "@mui/material";

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import PeriodComponent from "./PeriodComponent";
import { CommissionGroupModel, CommissionPediodModel, SalesmanModel } from "./SetupCommission";

interface CommissionGroupComponentProps {
    group: CommissionGroupModel;
    salesmen: SalesmanModel[];
    removeGroup: (group: CommissionGroupModel) => void;
}

const CommissionGroupComponent: FC<CommissionGroupComponentProps> = ({ group, salesmen, removeGroup }) => {
    const [groupName, setGroupName] = useState<string>("");
    const [selectedSales, setSelectedSales] = useState<number>(0);

    const [periods, setPeriods] = useState<CommissionPediodModel[]>([]);

    useEffect(() => {
        setGroupName(group.groupName);
        setSelectedSales(group.salesId);
        setPeriods(group.periods);
    }, [group])

    function SetGroupName(event: any) {
        var value = event.target.value;
        setGroupName(value);
        group.groupName = value;
    }

    function SelectSales(event: any) {
        var value = event.target.value;
        setSelectedSales(value);
        group.salesId = value;
    }

    function AddPeriod() {
        const newPeriod: CommissionPediodModel = {
            id: 0,
            percent: 0,
            startDate: dayjs(),
            endDate: null
        }
        var newArray = [...periods, newPeriod];
        group.periods = newArray;
        setPeriods(newArray);
    }

    const RemovePeriod = useCallback((period: CommissionPediodModel) => {
        const newArray: CommissionPediodModel[] = [];

        for (var i = 0; i < periods.length; i++) {
            if (periods[i] === period)
                continue;
            newArray.push(periods[i]);
        }
        group.periods = newArray;
        setPeriods(newArray);
    }, [periods]);

    return (
        <Stack direction={"column"}
            sx={{ border: "1px solid black" }}>
            {/* Group name */}
            <Stack
                direction={"row"}
                alignItems={"center"}>
                <p style={{ width: '80px' }}>Name: </p>
                <TextField
                    value={groupName}
                    onChange={SetGroupName}
                    sx={{ width: "200px" }}
                    size="small" />
                <IconButton
                    color="error"
                    size="large"
                    sx={{ width: "30px", height: "30px" }}
                    onClick={() => { removeGroup(group) }}>
                    <DeleteForeverIcon />
                </IconButton>
            </Stack>

            {/* Salesman */}
            <Stack direction={"row"}>
                <p style={{ width: '80px', marginTop: "10px" }}>Salesman: </p>
                <FormControl sx={{ width: "200px" }}>
                    <Select
                        value={selectedSales}
                        onChange={SelectSales}
                        size="small"
                        defaultValue={0}>
                        <MenuItem
                            value={0}>
                            <span><i>Select salesman</i></span>
                        </MenuItem>
                        {salesmen.map((salesman, index) =>
                            <MenuItem
                                key={index}
                                value={salesman.id}>
                                {salesman.sales}
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
            </Stack>

            {periods.map((period, index) =>
                <PeriodComponent
                    key={index}
                    period={period}
                    removePeriod={RemovePeriod} />
            )}
            <Button
                variant="outlined"
                onClick={AddPeriod}
                sx={{ width: '130px' }}>
                Add Period
            </Button>
        </Stack>
    )
}

export default CommissionGroupComponent;